/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StateTown } from './StateTown';
import {
    StateTownFromJSON,
    StateTownFromJSONTyped,
    StateTownToJSON,
    StateTownToJSONTyped,
} from './StateTown';

/**
 * 
 * @export
 * @interface OrganizationStateTown
 */
export interface OrganizationStateTown {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    organization_state_id?: string;
    /**
     * 
     */
    state_town_id?: string;
    /**
     * 
     */
    state_town?: StateTown;
}

/**
 * Check if a given object implements the OrganizationStateTown interface.
 */
export function instanceOfOrganizationStateTown(value: object): value is OrganizationStateTown {
    return true;
}

export function OrganizationStateTownFromJSON(json: any): OrganizationStateTown {
    return OrganizationStateTownFromJSONTyped(json, false);
}

export function OrganizationStateTownFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationStateTown {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organization_state_id': json['organization_state_id'] == null ? undefined : json['organization_state_id'],
        'state_town_id': json['state_town_id'] == null ? undefined : json['state_town_id'],
        'state_town': json['state_town'] == null ? undefined : StateTownFromJSON(json['state_town']),
    };
}

export function OrganizationStateTownToJSON(json: any): OrganizationStateTown {
    return OrganizationStateTownToJSONTyped(json, false);
}

export function OrganizationStateTownToJSONTyped(value?: OrganizationStateTown | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_state_id': value['organization_state_id'],
        'state_town_id': value['state_town_id'],
        'state_town': StateTownToJSON(value['state_town']),
    };
}

